import React from "react";
import _ from "lodash";
import TrustpilotWidget from "../../shared/Trustpilot";

interface TrustpilotWidgetFieldProps {
    templateId: string | undefined,
    reviewType: string | undefined,
    skuCode: string | undefined,
    width: string | undefined,
    height: string | undefined,
    stars: string | undefined,
}

export default function TrustpilotWidgetField({ templateId, reviewType, skuCode, width, height, stars }: TrustpilotWidgetFieldProps) {
    if (!templateId) {
        return <></>
    }

    return (
        <TrustpilotWidget
            className="trustpilot-widget w-full"
            data-locale={"en-GB"}
            data-template-id={templateId}
            data-sku={skuCode}
            data-theme={"light"}
            data-style-height={height}
            data-style-width={width || "100%"}
            data-stars={stars || "1,2,3,4,5"}
            data-no-reviews="hide"
            data-scroll-to-list="true"
            data-style-alignment="center"
        />
    );
}
